<template>
  <div style="height: 100%">
    <div class="research-detail-pc-body">
      <div class="body">
          <div class="title">{{item.title}}</div>
          <img :src="'static/pic/' + item.image"/>
          <div class="content">{{item.content}}</div>
      </div>
    </div>
    <div class="research-detail-mobile-body">
      <div class="mobile-body">
        <div class="title">{{item.title}}</div>
          <img :src="'static/pic/' + item.image"/>
          <div class="content">{{item.content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurLan} from '@/util/tools'
export default {
  name: 'research-detail-page',
  data () {
    return {
        item: {
            title: "(一) 超高时空分辨的先进表征技术的研发",
            image: "",
            content: "1). 太赫兹低温扫描隧道显微镜（THz-STM）的研发"
        }
    }
  },
  mounted () {
    this.item = this.$route.params
  }
}
</script>
<style lang='scss' src='../assets/styles/pc/research-detail-page.scss'></style>
<style lang='scss' src='../assets/styles/mobile/research-detail-page.scss'></style>


// WEBPACK FOOTER //
// src/components/ResearchDetail.vue